/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthErrorRouteImport } from './routes/auth-error'
import { Route as AuthRoutesRouteImport } from './routes/_auth-routes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRoutesProgramIdRouteImport } from './routes/_auth-routes/$programId'
import { Route as AuthRoutesProgramIdIndexRouteImport } from './routes/_auth-routes/$programId/index'
import { Route as AuthRoutesAdminUsersRouteImport } from './routes/_auth-routes/admin/users'
import { Route as AuthRoutesAdminUserProgramsRouteImport } from './routes/_auth-routes/admin/userPrograms'
import { Route as AuthRoutesAdminUserProgramRouteImport } from './routes/_auth-routes/admin/userProgram'
import { Route as AuthRoutesAdminUserRouteImport } from './routes/_auth-routes/admin/user'
import { Route as AuthRoutesAdminTableViewsRouteImport } from './routes/_auth-routes/admin/tableViews'
import { Route as AuthRoutesAdminTableViewRouteImport } from './routes/_auth-routes/admin/tableView'
import { Route as AuthRoutesAdminProgramsRouteImport } from './routes/_auth-routes/admin/programs'
import { Route as AuthRoutesAdminProgramLabelsRouteImport } from './routes/_auth-routes/admin/programLabels'
import { Route as AuthRoutesAdminProgramLabelRouteImport } from './routes/_auth-routes/admin/programLabel'
import { Route as AuthRoutesAdminProgramRouteImport } from './routes/_auth-routes/admin/program'
import { Route as AuthRoutesAdminPnlValuesRouteImport } from './routes/_auth-routes/admin/pnlValues'
import { Route as AuthRoutesAdminPnlValueRouteImport } from './routes/_auth-routes/admin/pnlValue'
import { Route as AuthRoutesAdminPnlStructuresRouteImport } from './routes/_auth-routes/admin/pnlStructures'
import { Route as AuthRoutesAdminPnlStructureRouteImport } from './routes/_auth-routes/admin/pnlStructure'
import { Route as AuthRoutesAdminPnlRowsRouteImport } from './routes/_auth-routes/admin/pnlRows'
import { Route as AuthRoutesAdminPnlRowRouteImport } from './routes/_auth-routes/admin/pnlRow'
import { Route as AuthRoutesAdminPersonsRouteImport } from './routes/_auth-routes/admin/persons'
import { Route as AuthRoutesAdminPersonHierarchyNodesRouteImport } from './routes/_auth-routes/admin/personHierarchyNodes'
import { Route as AuthRoutesAdminPersonHierarchyNodeRouteImport } from './routes/_auth-routes/admin/personHierarchyNode'
import { Route as AuthRoutesAdminPersonRouteImport } from './routes/_auth-routes/admin/person'
import { Route as AuthRoutesAdminPeriodsRouteImport } from './routes/_auth-routes/admin/periods'
import { Route as AuthRoutesAdminPeriodConfigurationsRouteImport } from './routes/_auth-routes/admin/periodConfigurations'
import { Route as AuthRoutesAdminPeriodConfigurationRouteImport } from './routes/_auth-routes/admin/periodConfiguration'
import { Route as AuthRoutesAdminPeriodRouteImport } from './routes/_auth-routes/admin/period'
import { Route as AuthRoutesAdminOrganizationsRouteImport } from './routes/_auth-routes/admin/organizations'
import { Route as AuthRoutesAdminOrganizationRouteImport } from './routes/_auth-routes/admin/organization'
import { Route as AuthRoutesAdminOneOffCostsRouteImport } from './routes/_auth-routes/admin/oneOffCosts'
import { Route as AuthRoutesAdminOneOffCostRouteImport } from './routes/_auth-routes/admin/oneOffCost'
import { Route as AuthRoutesAdminHierarchyNodesRouteImport } from './routes/_auth-routes/admin/hierarchyNodes'
import { Route as AuthRoutesAdminHierarchyNodeRouteImport } from './routes/_auth-routes/admin/hierarchyNode'
import { Route as AuthRoutesAdminHierarchyRouteImport } from './routes/_auth-routes/admin/hierarchy'
import { Route as AuthRoutesAdminHierarchiesRouteImport } from './routes/_auth-routes/admin/hierarchies'
import { Route as AuthRoutesAdminFilesRouteImport } from './routes/_auth-routes/admin/files'
import { Route as AuthRoutesAdminFileRouteImport } from './routes/_auth-routes/admin/file'
import { Route as AuthRoutesAdminDropDownsRouteImport } from './routes/_auth-routes/admin/dropDowns'
import { Route as AuthRoutesAdminDropDownElementsRouteImport } from './routes/_auth-routes/admin/dropDownElements'
import { Route as AuthRoutesAdminDropDownElementRouteImport } from './routes/_auth-routes/admin/dropDownElement'
import { Route as AuthRoutesAdminDropDownRouteImport } from './routes/_auth-routes/admin/dropDown'
import { Route as AuthRoutesAdminDeliverablesRouteImport } from './routes/_auth-routes/admin/deliverables'
import { Route as AuthRoutesAdminDeliverableOneOffCostItemsRouteImport } from './routes/_auth-routes/admin/deliverableOneOffCostItems'
import { Route as AuthRoutesAdminDeliverableOneOffCostItemRouteImport } from './routes/_auth-routes/admin/deliverableOneOffCostItem'
import { Route as AuthRoutesAdminDeliverableRouteImport } from './routes/_auth-routes/admin/deliverable'
import { Route as AuthRoutesAdminCommentsRouteImport } from './routes/_auth-routes/admin/comments'
import { Route as AuthRoutesAdminCommentRouteImport } from './routes/_auth-routes/admin/comment'
import { Route as AuthRoutesAdminActionsRouteImport } from './routes/_auth-routes/admin/actions'
import { Route as AuthRoutesAdminActionOperationsRouteImport } from './routes/_auth-routes/admin/actionOperations'
import { Route as AuthRoutesAdminActionOperationRouteImport } from './routes/_auth-routes/admin/actionOperation'
import { Route as AuthRoutesAdminActionRouteImport } from './routes/_auth-routes/admin/action'
import { Route as AuthRoutesProgramIdDeliverableIdTabRouteImport } from './routes/_auth-routes/$programId/$deliverableId/$tab'

const AuthRoutesAdminLazyRouteImport = createFileRoute('/_auth-routes/admin')()
const AuthRoutesAdminIndexLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/',
)()
const AuthRoutesAdminImportReviewLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/import-review',
)()
const AuthRoutesAdminExcelIoLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/excel-io',
)()
const AuthRoutesAdminDataManagementLazyRouteImport = createFileRoute(
  '/_auth-routes/admin/data-management',
)()
const AuthRoutesProgramIdDeliverableIdIndexLazyRouteImport = createFileRoute(
  '/_auth-routes/$programId/$deliverableId/',
)()

const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoutesRoute = AuthRoutesRouteImport.update({
  id: '/_auth-routes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoutesAdminLazyRoute = AuthRoutesAdminLazyRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoutesRoute,
} as any).lazy(() =>
  import('./routes/_auth-routes/admin.lazy').then((d) => d.Route),
)
const AuthRoutesProgramIdRoute = AuthRoutesProgramIdRouteImport.update({
  id: '/$programId',
  path: '/$programId',
  getParentRoute: () => AuthRoutesRoute,
} as any)
const AuthRoutesAdminIndexLazyRoute =
  AuthRoutesAdminIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/index.lazy').then((d) => d.Route),
  )
const AuthRoutesProgramIdIndexRoute =
  AuthRoutesProgramIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthRoutesProgramIdRoute,
  } as any)
const AuthRoutesAdminImportReviewLazyRoute =
  AuthRoutesAdminImportReviewLazyRouteImport.update({
    id: '/import-review',
    path: '/import-review',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/import-review.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesAdminExcelIoLazyRoute =
  AuthRoutesAdminExcelIoLazyRouteImport.update({
    id: '/excel-io',
    path: '/excel-io',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/excel-io.lazy').then((d) => d.Route),
  )
const AuthRoutesAdminDataManagementLazyRoute =
  AuthRoutesAdminDataManagementLazyRouteImport.update({
    id: '/data-management',
    path: '/data-management',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/admin/data-management.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesAdminUsersRoute = AuthRoutesAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminUserProgramsRoute =
  AuthRoutesAdminUserProgramsRouteImport.update({
    id: '/userPrograms',
    path: '/userPrograms',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminUserProgramRoute =
  AuthRoutesAdminUserProgramRouteImport.update({
    id: '/userProgram',
    path: '/userProgram',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminUserRoute = AuthRoutesAdminUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminTableViewsRoute =
  AuthRoutesAdminTableViewsRouteImport.update({
    id: '/tableViews',
    path: '/tableViews',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminTableViewRoute =
  AuthRoutesAdminTableViewRouteImport.update({
    id: '/tableView',
    path: '/tableView',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProgramsRoute = AuthRoutesAdminProgramsRouteImport.update({
  id: '/programs',
  path: '/programs',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminProgramLabelsRoute =
  AuthRoutesAdminProgramLabelsRouteImport.update({
    id: '/programLabels',
    path: '/programLabels',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProgramLabelRoute =
  AuthRoutesAdminProgramLabelRouteImport.update({
    id: '/programLabel',
    path: '/programLabel',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminProgramRoute = AuthRoutesAdminProgramRouteImport.update({
  id: '/program',
  path: '/program',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPnlValuesRoute =
  AuthRoutesAdminPnlValuesRouteImport.update({
    id: '/pnlValues',
    path: '/pnlValues',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPnlValueRoute = AuthRoutesAdminPnlValueRouteImport.update({
  id: '/pnlValue',
  path: '/pnlValue',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPnlStructuresRoute =
  AuthRoutesAdminPnlStructuresRouteImport.update({
    id: '/pnlStructures',
    path: '/pnlStructures',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPnlStructureRoute =
  AuthRoutesAdminPnlStructureRouteImport.update({
    id: '/pnlStructure',
    path: '/pnlStructure',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPnlRowsRoute = AuthRoutesAdminPnlRowsRouteImport.update({
  id: '/pnlRows',
  path: '/pnlRows',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPnlRowRoute = AuthRoutesAdminPnlRowRouteImport.update({
  id: '/pnlRow',
  path: '/pnlRow',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPersonsRoute = AuthRoutesAdminPersonsRouteImport.update({
  id: '/persons',
  path: '/persons',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPersonHierarchyNodesRoute =
  AuthRoutesAdminPersonHierarchyNodesRouteImport.update({
    id: '/personHierarchyNodes',
    path: '/personHierarchyNodes',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPersonHierarchyNodeRoute =
  AuthRoutesAdminPersonHierarchyNodeRouteImport.update({
    id: '/personHierarchyNode',
    path: '/personHierarchyNode',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPersonRoute = AuthRoutesAdminPersonRouteImport.update({
  id: '/person',
  path: '/person',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPeriodsRoute = AuthRoutesAdminPeriodsRouteImport.update({
  id: '/periods',
  path: '/periods',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminPeriodConfigurationsRoute =
  AuthRoutesAdminPeriodConfigurationsRouteImport.update({
    id: '/periodConfigurations',
    path: '/periodConfigurations',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPeriodConfigurationRoute =
  AuthRoutesAdminPeriodConfigurationRouteImport.update({
    id: '/periodConfiguration',
    path: '/periodConfiguration',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminPeriodRoute = AuthRoutesAdminPeriodRouteImport.update({
  id: '/period',
  path: '/period',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminOrganizationsRoute =
  AuthRoutesAdminOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminOrganizationRoute =
  AuthRoutesAdminOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminOneOffCostsRoute =
  AuthRoutesAdminOneOffCostsRouteImport.update({
    id: '/oneOffCosts',
    path: '/oneOffCosts',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminOneOffCostRoute =
  AuthRoutesAdminOneOffCostRouteImport.update({
    id: '/oneOffCost',
    path: '/oneOffCost',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminHierarchyNodesRoute =
  AuthRoutesAdminHierarchyNodesRouteImport.update({
    id: '/hierarchyNodes',
    path: '/hierarchyNodes',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminHierarchyNodeRoute =
  AuthRoutesAdminHierarchyNodeRouteImport.update({
    id: '/hierarchyNode',
    path: '/hierarchyNode',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminHierarchyRoute =
  AuthRoutesAdminHierarchyRouteImport.update({
    id: '/hierarchy',
    path: '/hierarchy',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminHierarchiesRoute =
  AuthRoutesAdminHierarchiesRouteImport.update({
    id: '/hierarchies',
    path: '/hierarchies',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminFilesRoute = AuthRoutesAdminFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminFileRoute = AuthRoutesAdminFileRouteImport.update({
  id: '/file',
  path: '/file',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminDropDownsRoute =
  AuthRoutesAdminDropDownsRouteImport.update({
    id: '/dropDowns',
    path: '/dropDowns',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDropDownElementsRoute =
  AuthRoutesAdminDropDownElementsRouteImport.update({
    id: '/dropDownElements',
    path: '/dropDownElements',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDropDownElementRoute =
  AuthRoutesAdminDropDownElementRouteImport.update({
    id: '/dropDownElement',
    path: '/dropDownElement',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDropDownRoute = AuthRoutesAdminDropDownRouteImport.update({
  id: '/dropDown',
  path: '/dropDown',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminDeliverablesRoute =
  AuthRoutesAdminDeliverablesRouteImport.update({
    id: '/deliverables',
    path: '/deliverables',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDeliverableOneOffCostItemsRoute =
  AuthRoutesAdminDeliverableOneOffCostItemsRouteImport.update({
    id: '/deliverableOneOffCostItems',
    path: '/deliverableOneOffCostItems',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDeliverableOneOffCostItemRoute =
  AuthRoutesAdminDeliverableOneOffCostItemRouteImport.update({
    id: '/deliverableOneOffCostItem',
    path: '/deliverableOneOffCostItem',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminDeliverableRoute =
  AuthRoutesAdminDeliverableRouteImport.update({
    id: '/deliverable',
    path: '/deliverable',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminCommentsRoute = AuthRoutesAdminCommentsRouteImport.update({
  id: '/comments',
  path: '/comments',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminCommentRoute = AuthRoutesAdminCommentRouteImport.update({
  id: '/comment',
  path: '/comment',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminActionsRoute = AuthRoutesAdminActionsRouteImport.update({
  id: '/actions',
  path: '/actions',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesAdminActionOperationsRoute =
  AuthRoutesAdminActionOperationsRouteImport.update({
    id: '/actionOperations',
    path: '/actionOperations',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminActionOperationRoute =
  AuthRoutesAdminActionOperationRouteImport.update({
    id: '/actionOperation',
    path: '/actionOperation',
    getParentRoute: () => AuthRoutesAdminLazyRoute,
  } as any)
const AuthRoutesAdminActionRoute = AuthRoutesAdminActionRouteImport.update({
  id: '/action',
  path: '/action',
  getParentRoute: () => AuthRoutesAdminLazyRoute,
} as any)
const AuthRoutesProgramIdDeliverableIdIndexLazyRoute =
  AuthRoutesProgramIdDeliverableIdIndexLazyRouteImport.update({
    id: '/$deliverableId/',
    path: '/$deliverableId/',
    getParentRoute: () => AuthRoutesProgramIdRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/$programId/$deliverableId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRoutesProgramIdDeliverableIdTabRoute =
  AuthRoutesProgramIdDeliverableIdTabRouteImport.update({
    id: '/$deliverableId/$tab',
    path: '/$deliverableId/$tab',
    getParentRoute: () => AuthRoutesProgramIdRoute,
  } as any).lazy(() =>
    import('./routes/_auth-routes/$programId/$deliverableId/$tab.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/$programId': typeof AuthRoutesProgramIdRouteWithChildren
  '/admin': typeof AuthRoutesAdminLazyRouteWithChildren
  '/admin/action': typeof AuthRoutesAdminActionRoute
  '/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/admin/deliverable': typeof AuthRoutesAdminDeliverableRoute
  '/admin/deliverableOneOffCostItem': typeof AuthRoutesAdminDeliverableOneOffCostItemRoute
  '/admin/deliverableOneOffCostItems': typeof AuthRoutesAdminDeliverableOneOffCostItemsRoute
  '/admin/deliverables': typeof AuthRoutesAdminDeliverablesRoute
  '/admin/dropDown': typeof AuthRoutesAdminDropDownRoute
  '/admin/dropDownElement': typeof AuthRoutesAdminDropDownElementRoute
  '/admin/dropDownElements': typeof AuthRoutesAdminDropDownElementsRoute
  '/admin/dropDowns': typeof AuthRoutesAdminDropDownsRoute
  '/admin/file': typeof AuthRoutesAdminFileRoute
  '/admin/files': typeof AuthRoutesAdminFilesRoute
  '/admin/hierarchies': typeof AuthRoutesAdminHierarchiesRoute
  '/admin/hierarchy': typeof AuthRoutesAdminHierarchyRoute
  '/admin/hierarchyNode': typeof AuthRoutesAdminHierarchyNodeRoute
  '/admin/hierarchyNodes': typeof AuthRoutesAdminHierarchyNodesRoute
  '/admin/oneOffCost': typeof AuthRoutesAdminOneOffCostRoute
  '/admin/oneOffCosts': typeof AuthRoutesAdminOneOffCostsRoute
  '/admin/organization': typeof AuthRoutesAdminOrganizationRoute
  '/admin/organizations': typeof AuthRoutesAdminOrganizationsRoute
  '/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/admin/periodConfiguration': typeof AuthRoutesAdminPeriodConfigurationRoute
  '/admin/periodConfigurations': typeof AuthRoutesAdminPeriodConfigurationsRoute
  '/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/admin/person': typeof AuthRoutesAdminPersonRoute
  '/admin/personHierarchyNode': typeof AuthRoutesAdminPersonHierarchyNodeRoute
  '/admin/personHierarchyNodes': typeof AuthRoutesAdminPersonHierarchyNodesRoute
  '/admin/persons': typeof AuthRoutesAdminPersonsRoute
  '/admin/pnlRow': typeof AuthRoutesAdminPnlRowRoute
  '/admin/pnlRows': typeof AuthRoutesAdminPnlRowsRoute
  '/admin/pnlStructure': typeof AuthRoutesAdminPnlStructureRoute
  '/admin/pnlStructures': typeof AuthRoutesAdminPnlStructuresRoute
  '/admin/pnlValue': typeof AuthRoutesAdminPnlValueRoute
  '/admin/pnlValues': typeof AuthRoutesAdminPnlValuesRoute
  '/admin/program': typeof AuthRoutesAdminProgramRoute
  '/admin/programLabel': typeof AuthRoutesAdminProgramLabelRoute
  '/admin/programLabels': typeof AuthRoutesAdminProgramLabelsRoute
  '/admin/programs': typeof AuthRoutesAdminProgramsRoute
  '/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/admin/user': typeof AuthRoutesAdminUserRoute
  '/admin/userProgram': typeof AuthRoutesAdminUserProgramRoute
  '/admin/userPrograms': typeof AuthRoutesAdminUserProgramsRoute
  '/admin/users': typeof AuthRoutesAdminUsersRoute
  '/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/$programId/': typeof AuthRoutesProgramIdIndexRoute
  '/admin/': typeof AuthRoutesAdminIndexLazyRoute
  '/$programId/$deliverableId/$tab': typeof AuthRoutesProgramIdDeliverableIdTabRoute
  '/$programId/$deliverableId': typeof AuthRoutesProgramIdDeliverableIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/admin/action': typeof AuthRoutesAdminActionRoute
  '/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/admin/deliverable': typeof AuthRoutesAdminDeliverableRoute
  '/admin/deliverableOneOffCostItem': typeof AuthRoutesAdminDeliverableOneOffCostItemRoute
  '/admin/deliverableOneOffCostItems': typeof AuthRoutesAdminDeliverableOneOffCostItemsRoute
  '/admin/deliverables': typeof AuthRoutesAdminDeliverablesRoute
  '/admin/dropDown': typeof AuthRoutesAdminDropDownRoute
  '/admin/dropDownElement': typeof AuthRoutesAdminDropDownElementRoute
  '/admin/dropDownElements': typeof AuthRoutesAdminDropDownElementsRoute
  '/admin/dropDowns': typeof AuthRoutesAdminDropDownsRoute
  '/admin/file': typeof AuthRoutesAdminFileRoute
  '/admin/files': typeof AuthRoutesAdminFilesRoute
  '/admin/hierarchies': typeof AuthRoutesAdminHierarchiesRoute
  '/admin/hierarchy': typeof AuthRoutesAdminHierarchyRoute
  '/admin/hierarchyNode': typeof AuthRoutesAdminHierarchyNodeRoute
  '/admin/hierarchyNodes': typeof AuthRoutesAdminHierarchyNodesRoute
  '/admin/oneOffCost': typeof AuthRoutesAdminOneOffCostRoute
  '/admin/oneOffCosts': typeof AuthRoutesAdminOneOffCostsRoute
  '/admin/organization': typeof AuthRoutesAdminOrganizationRoute
  '/admin/organizations': typeof AuthRoutesAdminOrganizationsRoute
  '/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/admin/periodConfiguration': typeof AuthRoutesAdminPeriodConfigurationRoute
  '/admin/periodConfigurations': typeof AuthRoutesAdminPeriodConfigurationsRoute
  '/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/admin/person': typeof AuthRoutesAdminPersonRoute
  '/admin/personHierarchyNode': typeof AuthRoutesAdminPersonHierarchyNodeRoute
  '/admin/personHierarchyNodes': typeof AuthRoutesAdminPersonHierarchyNodesRoute
  '/admin/persons': typeof AuthRoutesAdminPersonsRoute
  '/admin/pnlRow': typeof AuthRoutesAdminPnlRowRoute
  '/admin/pnlRows': typeof AuthRoutesAdminPnlRowsRoute
  '/admin/pnlStructure': typeof AuthRoutesAdminPnlStructureRoute
  '/admin/pnlStructures': typeof AuthRoutesAdminPnlStructuresRoute
  '/admin/pnlValue': typeof AuthRoutesAdminPnlValueRoute
  '/admin/pnlValues': typeof AuthRoutesAdminPnlValuesRoute
  '/admin/program': typeof AuthRoutesAdminProgramRoute
  '/admin/programLabel': typeof AuthRoutesAdminProgramLabelRoute
  '/admin/programLabels': typeof AuthRoutesAdminProgramLabelsRoute
  '/admin/programs': typeof AuthRoutesAdminProgramsRoute
  '/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/admin/user': typeof AuthRoutesAdminUserRoute
  '/admin/userProgram': typeof AuthRoutesAdminUserProgramRoute
  '/admin/userPrograms': typeof AuthRoutesAdminUserProgramsRoute
  '/admin/users': typeof AuthRoutesAdminUsersRoute
  '/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/$programId': typeof AuthRoutesProgramIdIndexRoute
  '/admin': typeof AuthRoutesAdminIndexLazyRoute
  '/$programId/$deliverableId/$tab': typeof AuthRoutesProgramIdDeliverableIdTabRoute
  '/$programId/$deliverableId': typeof AuthRoutesProgramIdDeliverableIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth-routes': typeof AuthRoutesRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_auth-routes/$programId': typeof AuthRoutesProgramIdRouteWithChildren
  '/_auth-routes/admin': typeof AuthRoutesAdminLazyRouteWithChildren
  '/_auth-routes/admin/action': typeof AuthRoutesAdminActionRoute
  '/_auth-routes/admin/actionOperation': typeof AuthRoutesAdminActionOperationRoute
  '/_auth-routes/admin/actionOperations': typeof AuthRoutesAdminActionOperationsRoute
  '/_auth-routes/admin/actions': typeof AuthRoutesAdminActionsRoute
  '/_auth-routes/admin/comment': typeof AuthRoutesAdminCommentRoute
  '/_auth-routes/admin/comments': typeof AuthRoutesAdminCommentsRoute
  '/_auth-routes/admin/deliverable': typeof AuthRoutesAdminDeliverableRoute
  '/_auth-routes/admin/deliverableOneOffCostItem': typeof AuthRoutesAdminDeliverableOneOffCostItemRoute
  '/_auth-routes/admin/deliverableOneOffCostItems': typeof AuthRoutesAdminDeliverableOneOffCostItemsRoute
  '/_auth-routes/admin/deliverables': typeof AuthRoutesAdminDeliverablesRoute
  '/_auth-routes/admin/dropDown': typeof AuthRoutesAdminDropDownRoute
  '/_auth-routes/admin/dropDownElement': typeof AuthRoutesAdminDropDownElementRoute
  '/_auth-routes/admin/dropDownElements': typeof AuthRoutesAdminDropDownElementsRoute
  '/_auth-routes/admin/dropDowns': typeof AuthRoutesAdminDropDownsRoute
  '/_auth-routes/admin/file': typeof AuthRoutesAdminFileRoute
  '/_auth-routes/admin/files': typeof AuthRoutesAdminFilesRoute
  '/_auth-routes/admin/hierarchies': typeof AuthRoutesAdminHierarchiesRoute
  '/_auth-routes/admin/hierarchy': typeof AuthRoutesAdminHierarchyRoute
  '/_auth-routes/admin/hierarchyNode': typeof AuthRoutesAdminHierarchyNodeRoute
  '/_auth-routes/admin/hierarchyNodes': typeof AuthRoutesAdminHierarchyNodesRoute
  '/_auth-routes/admin/oneOffCost': typeof AuthRoutesAdminOneOffCostRoute
  '/_auth-routes/admin/oneOffCosts': typeof AuthRoutesAdminOneOffCostsRoute
  '/_auth-routes/admin/organization': typeof AuthRoutesAdminOrganizationRoute
  '/_auth-routes/admin/organizations': typeof AuthRoutesAdminOrganizationsRoute
  '/_auth-routes/admin/period': typeof AuthRoutesAdminPeriodRoute
  '/_auth-routes/admin/periodConfiguration': typeof AuthRoutesAdminPeriodConfigurationRoute
  '/_auth-routes/admin/periodConfigurations': typeof AuthRoutesAdminPeriodConfigurationsRoute
  '/_auth-routes/admin/periods': typeof AuthRoutesAdminPeriodsRoute
  '/_auth-routes/admin/person': typeof AuthRoutesAdminPersonRoute
  '/_auth-routes/admin/personHierarchyNode': typeof AuthRoutesAdminPersonHierarchyNodeRoute
  '/_auth-routes/admin/personHierarchyNodes': typeof AuthRoutesAdminPersonHierarchyNodesRoute
  '/_auth-routes/admin/persons': typeof AuthRoutesAdminPersonsRoute
  '/_auth-routes/admin/pnlRow': typeof AuthRoutesAdminPnlRowRoute
  '/_auth-routes/admin/pnlRows': typeof AuthRoutesAdminPnlRowsRoute
  '/_auth-routes/admin/pnlStructure': typeof AuthRoutesAdminPnlStructureRoute
  '/_auth-routes/admin/pnlStructures': typeof AuthRoutesAdminPnlStructuresRoute
  '/_auth-routes/admin/pnlValue': typeof AuthRoutesAdminPnlValueRoute
  '/_auth-routes/admin/pnlValues': typeof AuthRoutesAdminPnlValuesRoute
  '/_auth-routes/admin/program': typeof AuthRoutesAdminProgramRoute
  '/_auth-routes/admin/programLabel': typeof AuthRoutesAdminProgramLabelRoute
  '/_auth-routes/admin/programLabels': typeof AuthRoutesAdminProgramLabelsRoute
  '/_auth-routes/admin/programs': typeof AuthRoutesAdminProgramsRoute
  '/_auth-routes/admin/tableView': typeof AuthRoutesAdminTableViewRoute
  '/_auth-routes/admin/tableViews': typeof AuthRoutesAdminTableViewsRoute
  '/_auth-routes/admin/user': typeof AuthRoutesAdminUserRoute
  '/_auth-routes/admin/userProgram': typeof AuthRoutesAdminUserProgramRoute
  '/_auth-routes/admin/userPrograms': typeof AuthRoutesAdminUserProgramsRoute
  '/_auth-routes/admin/users': typeof AuthRoutesAdminUsersRoute
  '/_auth-routes/admin/data-management': typeof AuthRoutesAdminDataManagementLazyRoute
  '/_auth-routes/admin/excel-io': typeof AuthRoutesAdminExcelIoLazyRoute
  '/_auth-routes/admin/import-review': typeof AuthRoutesAdminImportReviewLazyRoute
  '/_auth-routes/$programId/': typeof AuthRoutesProgramIdIndexRoute
  '/_auth-routes/admin/': typeof AuthRoutesAdminIndexLazyRoute
  '/_auth-routes/$programId/$deliverableId/$tab': typeof AuthRoutesProgramIdDeliverableIdTabRoute
  '/_auth-routes/$programId/$deliverableId/': typeof AuthRoutesProgramIdDeliverableIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-error'
    | '/login'
    | '/unauthorized'
    | '/$programId'
    | '/admin'
    | '/admin/action'
    | '/admin/actionOperation'
    | '/admin/actionOperations'
    | '/admin/actions'
    | '/admin/comment'
    | '/admin/comments'
    | '/admin/deliverable'
    | '/admin/deliverableOneOffCostItem'
    | '/admin/deliverableOneOffCostItems'
    | '/admin/deliverables'
    | '/admin/dropDown'
    | '/admin/dropDownElement'
    | '/admin/dropDownElements'
    | '/admin/dropDowns'
    | '/admin/file'
    | '/admin/files'
    | '/admin/hierarchies'
    | '/admin/hierarchy'
    | '/admin/hierarchyNode'
    | '/admin/hierarchyNodes'
    | '/admin/oneOffCost'
    | '/admin/oneOffCosts'
    | '/admin/organization'
    | '/admin/organizations'
    | '/admin/period'
    | '/admin/periodConfiguration'
    | '/admin/periodConfigurations'
    | '/admin/periods'
    | '/admin/person'
    | '/admin/personHierarchyNode'
    | '/admin/personHierarchyNodes'
    | '/admin/persons'
    | '/admin/pnlRow'
    | '/admin/pnlRows'
    | '/admin/pnlStructure'
    | '/admin/pnlStructures'
    | '/admin/pnlValue'
    | '/admin/pnlValues'
    | '/admin/program'
    | '/admin/programLabel'
    | '/admin/programLabels'
    | '/admin/programs'
    | '/admin/tableView'
    | '/admin/tableViews'
    | '/admin/user'
    | '/admin/userProgram'
    | '/admin/userPrograms'
    | '/admin/users'
    | '/admin/data-management'
    | '/admin/excel-io'
    | '/admin/import-review'
    | '/$programId/'
    | '/admin/'
    | '/$programId/$deliverableId/$tab'
    | '/$programId/$deliverableId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-error'
    | '/login'
    | '/unauthorized'
    | '/admin/action'
    | '/admin/actionOperation'
    | '/admin/actionOperations'
    | '/admin/actions'
    | '/admin/comment'
    | '/admin/comments'
    | '/admin/deliverable'
    | '/admin/deliverableOneOffCostItem'
    | '/admin/deliverableOneOffCostItems'
    | '/admin/deliverables'
    | '/admin/dropDown'
    | '/admin/dropDownElement'
    | '/admin/dropDownElements'
    | '/admin/dropDowns'
    | '/admin/file'
    | '/admin/files'
    | '/admin/hierarchies'
    | '/admin/hierarchy'
    | '/admin/hierarchyNode'
    | '/admin/hierarchyNodes'
    | '/admin/oneOffCost'
    | '/admin/oneOffCosts'
    | '/admin/organization'
    | '/admin/organizations'
    | '/admin/period'
    | '/admin/periodConfiguration'
    | '/admin/periodConfigurations'
    | '/admin/periods'
    | '/admin/person'
    | '/admin/personHierarchyNode'
    | '/admin/personHierarchyNodes'
    | '/admin/persons'
    | '/admin/pnlRow'
    | '/admin/pnlRows'
    | '/admin/pnlStructure'
    | '/admin/pnlStructures'
    | '/admin/pnlValue'
    | '/admin/pnlValues'
    | '/admin/program'
    | '/admin/programLabel'
    | '/admin/programLabels'
    | '/admin/programs'
    | '/admin/tableView'
    | '/admin/tableViews'
    | '/admin/user'
    | '/admin/userProgram'
    | '/admin/userPrograms'
    | '/admin/users'
    | '/admin/data-management'
    | '/admin/excel-io'
    | '/admin/import-review'
    | '/$programId'
    | '/admin'
    | '/$programId/$deliverableId/$tab'
    | '/$programId/$deliverableId'
  id:
    | '__root__'
    | '/'
    | '/_auth-routes'
    | '/auth-error'
    | '/login'
    | '/unauthorized'
    | '/_auth-routes/$programId'
    | '/_auth-routes/admin'
    | '/_auth-routes/admin/action'
    | '/_auth-routes/admin/actionOperation'
    | '/_auth-routes/admin/actionOperations'
    | '/_auth-routes/admin/actions'
    | '/_auth-routes/admin/comment'
    | '/_auth-routes/admin/comments'
    | '/_auth-routes/admin/deliverable'
    | '/_auth-routes/admin/deliverableOneOffCostItem'
    | '/_auth-routes/admin/deliverableOneOffCostItems'
    | '/_auth-routes/admin/deliverables'
    | '/_auth-routes/admin/dropDown'
    | '/_auth-routes/admin/dropDownElement'
    | '/_auth-routes/admin/dropDownElements'
    | '/_auth-routes/admin/dropDowns'
    | '/_auth-routes/admin/file'
    | '/_auth-routes/admin/files'
    | '/_auth-routes/admin/hierarchies'
    | '/_auth-routes/admin/hierarchy'
    | '/_auth-routes/admin/hierarchyNode'
    | '/_auth-routes/admin/hierarchyNodes'
    | '/_auth-routes/admin/oneOffCost'
    | '/_auth-routes/admin/oneOffCosts'
    | '/_auth-routes/admin/organization'
    | '/_auth-routes/admin/organizations'
    | '/_auth-routes/admin/period'
    | '/_auth-routes/admin/periodConfiguration'
    | '/_auth-routes/admin/periodConfigurations'
    | '/_auth-routes/admin/periods'
    | '/_auth-routes/admin/person'
    | '/_auth-routes/admin/personHierarchyNode'
    | '/_auth-routes/admin/personHierarchyNodes'
    | '/_auth-routes/admin/persons'
    | '/_auth-routes/admin/pnlRow'
    | '/_auth-routes/admin/pnlRows'
    | '/_auth-routes/admin/pnlStructure'
    | '/_auth-routes/admin/pnlStructures'
    | '/_auth-routes/admin/pnlValue'
    | '/_auth-routes/admin/pnlValues'
    | '/_auth-routes/admin/program'
    | '/_auth-routes/admin/programLabel'
    | '/_auth-routes/admin/programLabels'
    | '/_auth-routes/admin/programs'
    | '/_auth-routes/admin/tableView'
    | '/_auth-routes/admin/tableViews'
    | '/_auth-routes/admin/user'
    | '/_auth-routes/admin/userProgram'
    | '/_auth-routes/admin/userPrograms'
    | '/_auth-routes/admin/users'
    | '/_auth-routes/admin/data-management'
    | '/_auth-routes/admin/excel-io'
    | '/_auth-routes/admin/import-review'
    | '/_auth-routes/$programId/'
    | '/_auth-routes/admin/'
    | '/_auth-routes/$programId/$deliverableId/$tab'
    | '/_auth-routes/$programId/$deliverableId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoutesRoute: typeof AuthRoutesRouteWithChildren
  AuthErrorRoute: typeof AuthErrorRoute
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-error': {
      id: '/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-routes': {
      id: '/_auth-routes'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRoutesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-routes/admin': {
      id: '/_auth-routes/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthRoutesAdminLazyRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/$programId': {
      id: '/_auth-routes/$programId'
      path: '/$programId'
      fullPath: '/$programId'
      preLoaderRoute: typeof AuthRoutesProgramIdRouteImport
      parentRoute: typeof AuthRoutesRoute
    }
    '/_auth-routes/admin/': {
      id: '/_auth-routes/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthRoutesAdminIndexLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/$programId/': {
      id: '/_auth-routes/$programId/'
      path: '/'
      fullPath: '/$programId/'
      preLoaderRoute: typeof AuthRoutesProgramIdIndexRouteImport
      parentRoute: typeof AuthRoutesProgramIdRoute
    }
    '/_auth-routes/admin/import-review': {
      id: '/_auth-routes/admin/import-review'
      path: '/import-review'
      fullPath: '/admin/import-review'
      preLoaderRoute: typeof AuthRoutesAdminImportReviewLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/excel-io': {
      id: '/_auth-routes/admin/excel-io'
      path: '/excel-io'
      fullPath: '/admin/excel-io'
      preLoaderRoute: typeof AuthRoutesAdminExcelIoLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/data-management': {
      id: '/_auth-routes/admin/data-management'
      path: '/data-management'
      fullPath: '/admin/data-management'
      preLoaderRoute: typeof AuthRoutesAdminDataManagementLazyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/users': {
      id: '/_auth-routes/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthRoutesAdminUsersRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/userPrograms': {
      id: '/_auth-routes/admin/userPrograms'
      path: '/userPrograms'
      fullPath: '/admin/userPrograms'
      preLoaderRoute: typeof AuthRoutesAdminUserProgramsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/userProgram': {
      id: '/_auth-routes/admin/userProgram'
      path: '/userProgram'
      fullPath: '/admin/userProgram'
      preLoaderRoute: typeof AuthRoutesAdminUserProgramRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/user': {
      id: '/_auth-routes/admin/user'
      path: '/user'
      fullPath: '/admin/user'
      preLoaderRoute: typeof AuthRoutesAdminUserRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/tableViews': {
      id: '/_auth-routes/admin/tableViews'
      path: '/tableViews'
      fullPath: '/admin/tableViews'
      preLoaderRoute: typeof AuthRoutesAdminTableViewsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/tableView': {
      id: '/_auth-routes/admin/tableView'
      path: '/tableView'
      fullPath: '/admin/tableView'
      preLoaderRoute: typeof AuthRoutesAdminTableViewRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/programs': {
      id: '/_auth-routes/admin/programs'
      path: '/programs'
      fullPath: '/admin/programs'
      preLoaderRoute: typeof AuthRoutesAdminProgramsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/programLabels': {
      id: '/_auth-routes/admin/programLabels'
      path: '/programLabels'
      fullPath: '/admin/programLabels'
      preLoaderRoute: typeof AuthRoutesAdminProgramLabelsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/programLabel': {
      id: '/_auth-routes/admin/programLabel'
      path: '/programLabel'
      fullPath: '/admin/programLabel'
      preLoaderRoute: typeof AuthRoutesAdminProgramLabelRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/program': {
      id: '/_auth-routes/admin/program'
      path: '/program'
      fullPath: '/admin/program'
      preLoaderRoute: typeof AuthRoutesAdminProgramRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlValues': {
      id: '/_auth-routes/admin/pnlValues'
      path: '/pnlValues'
      fullPath: '/admin/pnlValues'
      preLoaderRoute: typeof AuthRoutesAdminPnlValuesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlValue': {
      id: '/_auth-routes/admin/pnlValue'
      path: '/pnlValue'
      fullPath: '/admin/pnlValue'
      preLoaderRoute: typeof AuthRoutesAdminPnlValueRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlStructures': {
      id: '/_auth-routes/admin/pnlStructures'
      path: '/pnlStructures'
      fullPath: '/admin/pnlStructures'
      preLoaderRoute: typeof AuthRoutesAdminPnlStructuresRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlStructure': {
      id: '/_auth-routes/admin/pnlStructure'
      path: '/pnlStructure'
      fullPath: '/admin/pnlStructure'
      preLoaderRoute: typeof AuthRoutesAdminPnlStructureRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlRows': {
      id: '/_auth-routes/admin/pnlRows'
      path: '/pnlRows'
      fullPath: '/admin/pnlRows'
      preLoaderRoute: typeof AuthRoutesAdminPnlRowsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/pnlRow': {
      id: '/_auth-routes/admin/pnlRow'
      path: '/pnlRow'
      fullPath: '/admin/pnlRow'
      preLoaderRoute: typeof AuthRoutesAdminPnlRowRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/persons': {
      id: '/_auth-routes/admin/persons'
      path: '/persons'
      fullPath: '/admin/persons'
      preLoaderRoute: typeof AuthRoutesAdminPersonsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/personHierarchyNodes': {
      id: '/_auth-routes/admin/personHierarchyNodes'
      path: '/personHierarchyNodes'
      fullPath: '/admin/personHierarchyNodes'
      preLoaderRoute: typeof AuthRoutesAdminPersonHierarchyNodesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/personHierarchyNode': {
      id: '/_auth-routes/admin/personHierarchyNode'
      path: '/personHierarchyNode'
      fullPath: '/admin/personHierarchyNode'
      preLoaderRoute: typeof AuthRoutesAdminPersonHierarchyNodeRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/person': {
      id: '/_auth-routes/admin/person'
      path: '/person'
      fullPath: '/admin/person'
      preLoaderRoute: typeof AuthRoutesAdminPersonRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/periods': {
      id: '/_auth-routes/admin/periods'
      path: '/periods'
      fullPath: '/admin/periods'
      preLoaderRoute: typeof AuthRoutesAdminPeriodsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/periodConfigurations': {
      id: '/_auth-routes/admin/periodConfigurations'
      path: '/periodConfigurations'
      fullPath: '/admin/periodConfigurations'
      preLoaderRoute: typeof AuthRoutesAdminPeriodConfigurationsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/periodConfiguration': {
      id: '/_auth-routes/admin/periodConfiguration'
      path: '/periodConfiguration'
      fullPath: '/admin/periodConfiguration'
      preLoaderRoute: typeof AuthRoutesAdminPeriodConfigurationRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/period': {
      id: '/_auth-routes/admin/period'
      path: '/period'
      fullPath: '/admin/period'
      preLoaderRoute: typeof AuthRoutesAdminPeriodRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/organizations': {
      id: '/_auth-routes/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AuthRoutesAdminOrganizationsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/organization': {
      id: '/_auth-routes/admin/organization'
      path: '/organization'
      fullPath: '/admin/organization'
      preLoaderRoute: typeof AuthRoutesAdminOrganizationRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/oneOffCosts': {
      id: '/_auth-routes/admin/oneOffCosts'
      path: '/oneOffCosts'
      fullPath: '/admin/oneOffCosts'
      preLoaderRoute: typeof AuthRoutesAdminOneOffCostsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/oneOffCost': {
      id: '/_auth-routes/admin/oneOffCost'
      path: '/oneOffCost'
      fullPath: '/admin/oneOffCost'
      preLoaderRoute: typeof AuthRoutesAdminOneOffCostRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/hierarchyNodes': {
      id: '/_auth-routes/admin/hierarchyNodes'
      path: '/hierarchyNodes'
      fullPath: '/admin/hierarchyNodes'
      preLoaderRoute: typeof AuthRoutesAdminHierarchyNodesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/hierarchyNode': {
      id: '/_auth-routes/admin/hierarchyNode'
      path: '/hierarchyNode'
      fullPath: '/admin/hierarchyNode'
      preLoaderRoute: typeof AuthRoutesAdminHierarchyNodeRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/hierarchy': {
      id: '/_auth-routes/admin/hierarchy'
      path: '/hierarchy'
      fullPath: '/admin/hierarchy'
      preLoaderRoute: typeof AuthRoutesAdminHierarchyRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/hierarchies': {
      id: '/_auth-routes/admin/hierarchies'
      path: '/hierarchies'
      fullPath: '/admin/hierarchies'
      preLoaderRoute: typeof AuthRoutesAdminHierarchiesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/files': {
      id: '/_auth-routes/admin/files'
      path: '/files'
      fullPath: '/admin/files'
      preLoaderRoute: typeof AuthRoutesAdminFilesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/file': {
      id: '/_auth-routes/admin/file'
      path: '/file'
      fullPath: '/admin/file'
      preLoaderRoute: typeof AuthRoutesAdminFileRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/dropDowns': {
      id: '/_auth-routes/admin/dropDowns'
      path: '/dropDowns'
      fullPath: '/admin/dropDowns'
      preLoaderRoute: typeof AuthRoutesAdminDropDownsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/dropDownElements': {
      id: '/_auth-routes/admin/dropDownElements'
      path: '/dropDownElements'
      fullPath: '/admin/dropDownElements'
      preLoaderRoute: typeof AuthRoutesAdminDropDownElementsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/dropDownElement': {
      id: '/_auth-routes/admin/dropDownElement'
      path: '/dropDownElement'
      fullPath: '/admin/dropDownElement'
      preLoaderRoute: typeof AuthRoutesAdminDropDownElementRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/dropDown': {
      id: '/_auth-routes/admin/dropDown'
      path: '/dropDown'
      fullPath: '/admin/dropDown'
      preLoaderRoute: typeof AuthRoutesAdminDropDownRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/deliverables': {
      id: '/_auth-routes/admin/deliverables'
      path: '/deliverables'
      fullPath: '/admin/deliverables'
      preLoaderRoute: typeof AuthRoutesAdminDeliverablesRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/deliverableOneOffCostItems': {
      id: '/_auth-routes/admin/deliverableOneOffCostItems'
      path: '/deliverableOneOffCostItems'
      fullPath: '/admin/deliverableOneOffCostItems'
      preLoaderRoute: typeof AuthRoutesAdminDeliverableOneOffCostItemsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/deliverableOneOffCostItem': {
      id: '/_auth-routes/admin/deliverableOneOffCostItem'
      path: '/deliverableOneOffCostItem'
      fullPath: '/admin/deliverableOneOffCostItem'
      preLoaderRoute: typeof AuthRoutesAdminDeliverableOneOffCostItemRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/deliverable': {
      id: '/_auth-routes/admin/deliverable'
      path: '/deliverable'
      fullPath: '/admin/deliverable'
      preLoaderRoute: typeof AuthRoutesAdminDeliverableRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/comments': {
      id: '/_auth-routes/admin/comments'
      path: '/comments'
      fullPath: '/admin/comments'
      preLoaderRoute: typeof AuthRoutesAdminCommentsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/comment': {
      id: '/_auth-routes/admin/comment'
      path: '/comment'
      fullPath: '/admin/comment'
      preLoaderRoute: typeof AuthRoutesAdminCommentRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actions': {
      id: '/_auth-routes/admin/actions'
      path: '/actions'
      fullPath: '/admin/actions'
      preLoaderRoute: typeof AuthRoutesAdminActionsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actionOperations': {
      id: '/_auth-routes/admin/actionOperations'
      path: '/actionOperations'
      fullPath: '/admin/actionOperations'
      preLoaderRoute: typeof AuthRoutesAdminActionOperationsRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/actionOperation': {
      id: '/_auth-routes/admin/actionOperation'
      path: '/actionOperation'
      fullPath: '/admin/actionOperation'
      preLoaderRoute: typeof AuthRoutesAdminActionOperationRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/admin/action': {
      id: '/_auth-routes/admin/action'
      path: '/action'
      fullPath: '/admin/action'
      preLoaderRoute: typeof AuthRoutesAdminActionRouteImport
      parentRoute: typeof AuthRoutesAdminLazyRoute
    }
    '/_auth-routes/$programId/$deliverableId/': {
      id: '/_auth-routes/$programId/$deliverableId/'
      path: '/$deliverableId'
      fullPath: '/$programId/$deliverableId'
      preLoaderRoute: typeof AuthRoutesProgramIdDeliverableIdIndexLazyRouteImport
      parentRoute: typeof AuthRoutesProgramIdRoute
    }
    '/_auth-routes/$programId/$deliverableId/$tab': {
      id: '/_auth-routes/$programId/$deliverableId/$tab'
      path: '/$deliverableId/$tab'
      fullPath: '/$programId/$deliverableId/$tab'
      preLoaderRoute: typeof AuthRoutesProgramIdDeliverableIdTabRouteImport
      parentRoute: typeof AuthRoutesProgramIdRoute
    }
  }
}

interface AuthRoutesProgramIdRouteChildren {
  AuthRoutesProgramIdIndexRoute: typeof AuthRoutesProgramIdIndexRoute
  AuthRoutesProgramIdDeliverableIdTabRoute: typeof AuthRoutesProgramIdDeliverableIdTabRoute
  AuthRoutesProgramIdDeliverableIdIndexLazyRoute: typeof AuthRoutesProgramIdDeliverableIdIndexLazyRoute
}

const AuthRoutesProgramIdRouteChildren: AuthRoutesProgramIdRouteChildren = {
  AuthRoutesProgramIdIndexRoute: AuthRoutesProgramIdIndexRoute,
  AuthRoutesProgramIdDeliverableIdTabRoute:
    AuthRoutesProgramIdDeliverableIdTabRoute,
  AuthRoutesProgramIdDeliverableIdIndexLazyRoute:
    AuthRoutesProgramIdDeliverableIdIndexLazyRoute,
}

const AuthRoutesProgramIdRouteWithChildren =
  AuthRoutesProgramIdRoute._addFileChildren(AuthRoutesProgramIdRouteChildren)

interface AuthRoutesAdminLazyRouteChildren {
  AuthRoutesAdminActionRoute: typeof AuthRoutesAdminActionRoute
  AuthRoutesAdminActionOperationRoute: typeof AuthRoutesAdminActionOperationRoute
  AuthRoutesAdminActionOperationsRoute: typeof AuthRoutesAdminActionOperationsRoute
  AuthRoutesAdminActionsRoute: typeof AuthRoutesAdminActionsRoute
  AuthRoutesAdminCommentRoute: typeof AuthRoutesAdminCommentRoute
  AuthRoutesAdminCommentsRoute: typeof AuthRoutesAdminCommentsRoute
  AuthRoutesAdminDeliverableRoute: typeof AuthRoutesAdminDeliverableRoute
  AuthRoutesAdminDeliverableOneOffCostItemRoute: typeof AuthRoutesAdminDeliverableOneOffCostItemRoute
  AuthRoutesAdminDeliverableOneOffCostItemsRoute: typeof AuthRoutesAdminDeliverableOneOffCostItemsRoute
  AuthRoutesAdminDeliverablesRoute: typeof AuthRoutesAdminDeliverablesRoute
  AuthRoutesAdminDropDownRoute: typeof AuthRoutesAdminDropDownRoute
  AuthRoutesAdminDropDownElementRoute: typeof AuthRoutesAdminDropDownElementRoute
  AuthRoutesAdminDropDownElementsRoute: typeof AuthRoutesAdminDropDownElementsRoute
  AuthRoutesAdminDropDownsRoute: typeof AuthRoutesAdminDropDownsRoute
  AuthRoutesAdminFileRoute: typeof AuthRoutesAdminFileRoute
  AuthRoutesAdminFilesRoute: typeof AuthRoutesAdminFilesRoute
  AuthRoutesAdminHierarchiesRoute: typeof AuthRoutesAdminHierarchiesRoute
  AuthRoutesAdminHierarchyRoute: typeof AuthRoutesAdminHierarchyRoute
  AuthRoutesAdminHierarchyNodeRoute: typeof AuthRoutesAdminHierarchyNodeRoute
  AuthRoutesAdminHierarchyNodesRoute: typeof AuthRoutesAdminHierarchyNodesRoute
  AuthRoutesAdminOneOffCostRoute: typeof AuthRoutesAdminOneOffCostRoute
  AuthRoutesAdminOneOffCostsRoute: typeof AuthRoutesAdminOneOffCostsRoute
  AuthRoutesAdminOrganizationRoute: typeof AuthRoutesAdminOrganizationRoute
  AuthRoutesAdminOrganizationsRoute: typeof AuthRoutesAdminOrganizationsRoute
  AuthRoutesAdminPeriodRoute: typeof AuthRoutesAdminPeriodRoute
  AuthRoutesAdminPeriodConfigurationRoute: typeof AuthRoutesAdminPeriodConfigurationRoute
  AuthRoutesAdminPeriodConfigurationsRoute: typeof AuthRoutesAdminPeriodConfigurationsRoute
  AuthRoutesAdminPeriodsRoute: typeof AuthRoutesAdminPeriodsRoute
  AuthRoutesAdminPersonRoute: typeof AuthRoutesAdminPersonRoute
  AuthRoutesAdminPersonHierarchyNodeRoute: typeof AuthRoutesAdminPersonHierarchyNodeRoute
  AuthRoutesAdminPersonHierarchyNodesRoute: typeof AuthRoutesAdminPersonHierarchyNodesRoute
  AuthRoutesAdminPersonsRoute: typeof AuthRoutesAdminPersonsRoute
  AuthRoutesAdminPnlRowRoute: typeof AuthRoutesAdminPnlRowRoute
  AuthRoutesAdminPnlRowsRoute: typeof AuthRoutesAdminPnlRowsRoute
  AuthRoutesAdminPnlStructureRoute: typeof AuthRoutesAdminPnlStructureRoute
  AuthRoutesAdminPnlStructuresRoute: typeof AuthRoutesAdminPnlStructuresRoute
  AuthRoutesAdminPnlValueRoute: typeof AuthRoutesAdminPnlValueRoute
  AuthRoutesAdminPnlValuesRoute: typeof AuthRoutesAdminPnlValuesRoute
  AuthRoutesAdminProgramRoute: typeof AuthRoutesAdminProgramRoute
  AuthRoutesAdminProgramLabelRoute: typeof AuthRoutesAdminProgramLabelRoute
  AuthRoutesAdminProgramLabelsRoute: typeof AuthRoutesAdminProgramLabelsRoute
  AuthRoutesAdminProgramsRoute: typeof AuthRoutesAdminProgramsRoute
  AuthRoutesAdminTableViewRoute: typeof AuthRoutesAdminTableViewRoute
  AuthRoutesAdminTableViewsRoute: typeof AuthRoutesAdminTableViewsRoute
  AuthRoutesAdminUserRoute: typeof AuthRoutesAdminUserRoute
  AuthRoutesAdminUserProgramRoute: typeof AuthRoutesAdminUserProgramRoute
  AuthRoutesAdminUserProgramsRoute: typeof AuthRoutesAdminUserProgramsRoute
  AuthRoutesAdminUsersRoute: typeof AuthRoutesAdminUsersRoute
  AuthRoutesAdminDataManagementLazyRoute: typeof AuthRoutesAdminDataManagementLazyRoute
  AuthRoutesAdminExcelIoLazyRoute: typeof AuthRoutesAdminExcelIoLazyRoute
  AuthRoutesAdminImportReviewLazyRoute: typeof AuthRoutesAdminImportReviewLazyRoute
  AuthRoutesAdminIndexLazyRoute: typeof AuthRoutesAdminIndexLazyRoute
}

const AuthRoutesAdminLazyRouteChildren: AuthRoutesAdminLazyRouteChildren = {
  AuthRoutesAdminActionRoute: AuthRoutesAdminActionRoute,
  AuthRoutesAdminActionOperationRoute: AuthRoutesAdminActionOperationRoute,
  AuthRoutesAdminActionOperationsRoute: AuthRoutesAdminActionOperationsRoute,
  AuthRoutesAdminActionsRoute: AuthRoutesAdminActionsRoute,
  AuthRoutesAdminCommentRoute: AuthRoutesAdminCommentRoute,
  AuthRoutesAdminCommentsRoute: AuthRoutesAdminCommentsRoute,
  AuthRoutesAdminDeliverableRoute: AuthRoutesAdminDeliverableRoute,
  AuthRoutesAdminDeliverableOneOffCostItemRoute:
    AuthRoutesAdminDeliverableOneOffCostItemRoute,
  AuthRoutesAdminDeliverableOneOffCostItemsRoute:
    AuthRoutesAdminDeliverableOneOffCostItemsRoute,
  AuthRoutesAdminDeliverablesRoute: AuthRoutesAdminDeliverablesRoute,
  AuthRoutesAdminDropDownRoute: AuthRoutesAdminDropDownRoute,
  AuthRoutesAdminDropDownElementRoute: AuthRoutesAdminDropDownElementRoute,
  AuthRoutesAdminDropDownElementsRoute: AuthRoutesAdminDropDownElementsRoute,
  AuthRoutesAdminDropDownsRoute: AuthRoutesAdminDropDownsRoute,
  AuthRoutesAdminFileRoute: AuthRoutesAdminFileRoute,
  AuthRoutesAdminFilesRoute: AuthRoutesAdminFilesRoute,
  AuthRoutesAdminHierarchiesRoute: AuthRoutesAdminHierarchiesRoute,
  AuthRoutesAdminHierarchyRoute: AuthRoutesAdminHierarchyRoute,
  AuthRoutesAdminHierarchyNodeRoute: AuthRoutesAdminHierarchyNodeRoute,
  AuthRoutesAdminHierarchyNodesRoute: AuthRoutesAdminHierarchyNodesRoute,
  AuthRoutesAdminOneOffCostRoute: AuthRoutesAdminOneOffCostRoute,
  AuthRoutesAdminOneOffCostsRoute: AuthRoutesAdminOneOffCostsRoute,
  AuthRoutesAdminOrganizationRoute: AuthRoutesAdminOrganizationRoute,
  AuthRoutesAdminOrganizationsRoute: AuthRoutesAdminOrganizationsRoute,
  AuthRoutesAdminPeriodRoute: AuthRoutesAdminPeriodRoute,
  AuthRoutesAdminPeriodConfigurationRoute:
    AuthRoutesAdminPeriodConfigurationRoute,
  AuthRoutesAdminPeriodConfigurationsRoute:
    AuthRoutesAdminPeriodConfigurationsRoute,
  AuthRoutesAdminPeriodsRoute: AuthRoutesAdminPeriodsRoute,
  AuthRoutesAdminPersonRoute: AuthRoutesAdminPersonRoute,
  AuthRoutesAdminPersonHierarchyNodeRoute:
    AuthRoutesAdminPersonHierarchyNodeRoute,
  AuthRoutesAdminPersonHierarchyNodesRoute:
    AuthRoutesAdminPersonHierarchyNodesRoute,
  AuthRoutesAdminPersonsRoute: AuthRoutesAdminPersonsRoute,
  AuthRoutesAdminPnlRowRoute: AuthRoutesAdminPnlRowRoute,
  AuthRoutesAdminPnlRowsRoute: AuthRoutesAdminPnlRowsRoute,
  AuthRoutesAdminPnlStructureRoute: AuthRoutesAdminPnlStructureRoute,
  AuthRoutesAdminPnlStructuresRoute: AuthRoutesAdminPnlStructuresRoute,
  AuthRoutesAdminPnlValueRoute: AuthRoutesAdminPnlValueRoute,
  AuthRoutesAdminPnlValuesRoute: AuthRoutesAdminPnlValuesRoute,
  AuthRoutesAdminProgramRoute: AuthRoutesAdminProgramRoute,
  AuthRoutesAdminProgramLabelRoute: AuthRoutesAdminProgramLabelRoute,
  AuthRoutesAdminProgramLabelsRoute: AuthRoutesAdminProgramLabelsRoute,
  AuthRoutesAdminProgramsRoute: AuthRoutesAdminProgramsRoute,
  AuthRoutesAdminTableViewRoute: AuthRoutesAdminTableViewRoute,
  AuthRoutesAdminTableViewsRoute: AuthRoutesAdminTableViewsRoute,
  AuthRoutesAdminUserRoute: AuthRoutesAdminUserRoute,
  AuthRoutesAdminUserProgramRoute: AuthRoutesAdminUserProgramRoute,
  AuthRoutesAdminUserProgramsRoute: AuthRoutesAdminUserProgramsRoute,
  AuthRoutesAdminUsersRoute: AuthRoutesAdminUsersRoute,
  AuthRoutesAdminDataManagementLazyRoute:
    AuthRoutesAdminDataManagementLazyRoute,
  AuthRoutesAdminExcelIoLazyRoute: AuthRoutesAdminExcelIoLazyRoute,
  AuthRoutesAdminImportReviewLazyRoute: AuthRoutesAdminImportReviewLazyRoute,
  AuthRoutesAdminIndexLazyRoute: AuthRoutesAdminIndexLazyRoute,
}

const AuthRoutesAdminLazyRouteWithChildren =
  AuthRoutesAdminLazyRoute._addFileChildren(AuthRoutesAdminLazyRouteChildren)

interface AuthRoutesRouteChildren {
  AuthRoutesProgramIdRoute: typeof AuthRoutesProgramIdRouteWithChildren
  AuthRoutesAdminLazyRoute: typeof AuthRoutesAdminLazyRouteWithChildren
}

const AuthRoutesRouteChildren: AuthRoutesRouteChildren = {
  AuthRoutesProgramIdRoute: AuthRoutesProgramIdRouteWithChildren,
  AuthRoutesAdminLazyRoute: AuthRoutesAdminLazyRouteWithChildren,
}

const AuthRoutesRouteWithChildren = AuthRoutesRoute._addFileChildren(
  AuthRoutesRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoutesRoute: AuthRoutesRouteWithChildren,
  AuthErrorRoute: AuthErrorRoute,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
